const header = document.querySelector('.header');
const SCROLL_THRESHOLD = 150;
const SCROLL_TOLERANCE = 25; // Marge de tolérance pour éviter les oscillations
let ticking = false;
let lastChange = 0;
const MIN_CHANGE_DELAY = 100; // Délai minimum entre les changements en ms

function handleScroll() {
  if (!ticking) {
    requestAnimationFrame(() => {
      const scrollY = window.scrollY || window.pageYOffset;
      const hasBg = header.hasAttribute('data-bg');
      const now = Date.now();

      if (now - lastChange >= MIN_CHANGE_DELAY) {
        if (!hasBg && scrollY >= SCROLL_THRESHOLD + SCROLL_TOLERANCE) {
          header.setAttribute('data-bg', 'true');
          lastChange = now;
        } else if (hasBg && scrollY <= SCROLL_THRESHOLD - SCROLL_TOLERANCE) {
          header.removeAttribute('data-bg');
          lastChange = now;
        }
      }
      
      ticking = false;
    });

    ticking = true;
  }
}

// Call handleScroll on page load
handleScroll();

// Add event listener for scroll
window.addEventListener('scroll', handleScroll);

const burgerIcon = document.querySelector('.header__burger-icon');

burgerIcon.addEventListener('click', () => {
  if (header.hasAttribute('data-deployed')) {
    header.removeAttribute('data-deployed');
  } else {
    header.setAttribute('data-deployed', 'true');
  }
});

const menuItemHasChildren = document.querySelectorAll(
  '.header__menu > .menu-item.menu-item-has-children'
);

menuItemHasChildren.forEach((item) => {
  item.setAttribute('aria-expanded', 'false');
  if (window.innerWidth < 992) {
    item.addEventListener('click', (e) => {
      const isOpen = item.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        if (e.target.tagName.toLowerCase() === 'a') return;
        item.setAttribute('aria-expanded', 'false');
      } else {
        item.setAttribute('aria-expanded', 'true');
        e.preventDefault();
      }
    });
  }
});
